import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const ChevronLeft = ({ fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5263 27L10 17L20.5263 7L22 8.425L12.9737 17L22 25.575L20.5263 27Z" fill={fill} />
    </svg>
  );
};
